module.exports = __webpack_public_path__ + "static/media/mail.7d44d93f.png";